<template>
  <footer>
    <p>&copy; 2024 Speak Easy. All rights reserved.</p>
  </footer>
</template>

<script>
export default {
  name: "FooterSection",
};
</script>

<style scoped>
footer {
  text-align: center;
  padding: 10px;
  background: #333;
  color: white;
}
</style>
